import React, { useEffect, useState } from "react";
import styles from "./CreditPackagesPage.module.css";
import { Link } from "react-router-dom";
import Layout from "../../Components/Layout";
import ProPlanTab from "../ComapnyDetails/proPlanTab";
import EnterprisePlanTab from "../ComapnyDetails/enterprisePlanTab";
import { FaBolt } from "react-icons/fa";
import { creditPricing } from "../../Services/APIrequests";
import Nav from "../../Components/LandingPage/Nav/Nav";

const CreditPackagesPage = () => {
    const [pricingData, setPricingData] = useState([]);
    const [activeTab, setActiveTab] = useState("Current Plan");

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    useEffect(() => {
        const fetchCreditPricing = async () => {
            try {
                const response = await creditPricing();
                setPricingData(response.data);
                console.log("fetching credit pricing:", response.data);
            } catch (error) {
                console.error("Error fetching credit pricing:", error);
            }
        };
        fetchCreditPricing();
    }, []);

    // This function will now return all pricing data
    const getFilteredData = () => {
        // Return all pricing data
        return pricingData;
    };

    // Call getFilteredData which will now return all plans
    const filteredData = getFilteredData();

    return (
        // <Layout Active={"My Credits"}>
        
        <div className={styles.subscription_page}>
            <Nav/>
            <div className={styles.headerSection}>
                <div className={styles.badge}>
                    <FaBolt className={styles.badgeIcon} />
                    <span>FLEXIBLE CREDIT PLANS</span>
                </div>
                <h1 className={styles.mainHeading}>
                    Choose Your <span className={styles.blueText}>Compliance Plan</span>
                </h1>
                <p className={styles.subHeading}>
                    Use credits for any compliance service — Company MCA Data and more. Pay only for what you need. Credits never expire.
                </p>
            </div>
            {/* <div className={styles.pricingcontainer}>
                <div className={styles.subscription_pageheader}>
            <input type="text" placeholder="Search for Company Name or CIN" />
          </div>
            </div> */}
            <div>
                {/* <div className={styles.subscription_pagetabs}>
                    {["Current Plan"].map((tab) => (
                        <button
                            key={tab}
                            onClick={() => handleTabClick(tab)}
                            className={`${styles.subscription_pagetab} ${activeTab === tab ? styles.subscription_pageactiveTab : ""
                                }`}
                        >
                            {tab}
                        </button>
                    ))}
                </div> */}

                <div>
                    {activeTab === "Current Plan" && <ProPlanTab data={filteredData} />}
                    {/* {activeTab === "Enterprise Plan" && (
               <EnterprisePlanTab data={filteredData} />
             )} */}
                    {/* Render All Plans */}
                    {activeTab !== "Current Plan" && activeTab !== "Enterprise Plan" && (
                        <div>
                            {filteredData.map((plan, index) => (
                                <div key={plan.creditPricingId}>
                                    <h3>{plan.planName}</h3>
                                    <p>Min Credits: {plan.minCredits}</p>
                                    <p>Max Credits: {plan.maxCredits}</p>
                                    <p>Price Per Credit: {plan.pricePerCredit}</p>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
        // </Layout>
    );
};

export default CreditPackagesPage;
